<div class="modal-container request-deletion-modal-container">
  <div class="modal-content">
    <div class="modal-header">
      <h4
        class="modal-title"
        id="modal-basic-title"
        [innerHtml]="'personalInfo.requestDeleteAcct.title' | cxTranslate"
      ></h4>
      <button type="button" class="close" aria-label="Close" (click)="closeModal('Cross click')">
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="modal-info" [innerHtml]="'personalInfo.requestDeleteAcct.body' | cxTranslate"></div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn secondary-btn cancel-btn mw-120"
        [innerHtml]="'personalInfo.requestDeleteAcct.cancelBtn' | cxTranslate"
        (click)="closeModal('Cross click')"
      ></button>
      <button
        type="button"
        class="btn primary-btn save-btn mw-120"
        [innerHtml]="'personalInfo.requestDeleteAcct.deleteBtn' | cxTranslate"
        (click)="onRequestDeleteAccount()"
      ></button>
    </div>
  </div>
</div>
